"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamingLanding = void 0;
var _react = require("react");
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _RTMPIcon = require("./RTMPIcon");
var _Common = require("./Common");
var _HLSStreaming = require("./HLSStreaming");
var _RTMPStreaming = require("./RTMPStreaming");
var _useSidepane = require("../AppData/useSidepane");
var _constants = require("../../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var StreamingLanding = function StreamingLanding() {
  var toggleStreaming = (0, _useSidepane.useSidepaneToggle)(_constants.SIDE_PANE_OPTIONS.STREAMING);
  var _useRecordingStreamin = (0, _reactSdk.useRecordingStreaming)(),
    isHLSRunning = _useRecordingStreamin.isHLSRunning,
    isRTMPRunning = _useRecordingStreamin.isRTMPRunning;
  var permissions = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions);
  var _useState = (0, _react.useState)(isHLSRunning),
    _useState2 = _slicedToArray(_useState, 2),
    showHLS = _useState2[0],
    setShowHLS = _useState2[1];
  var _useState3 = (0, _react.useState)(isRTMPRunning),
    _useState4 = _slicedToArray(_useState3, 2),
    showRTMP = _useState4[0],
    setShowRTMP = _useState4[1];
  if (!(permissions !== null && permissions !== void 0 && permissions.hlsStreaming) && !(permissions !== null && permissions !== void 0 && permissions.rtmpStreaming)) {
    toggleStreaming();
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      css: {
        w: "100%",
        py: "$8"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
        css: {
          alignSelf: "center",
          p: "$4",
          bg: "$surfaceLight",
          r: "$round"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ColoredHandIcon, {
          width: 40,
          height: 40
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
        css: {
          flex: "1 1 0",
          mx: "$8"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          children: "Welcome !"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "h6",
          children: "Let\u2019s get you started"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
        onClick: toggleStreaming,
        css: {
          alignSelf: "flex-start"
        },
        "data-testid": "close_streaming",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CrossIcon, {})
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "tiny",
      color: "$textMedEmp",
      children: "Start Streaming"
    }), (permissions === null || permissions === void 0 ? void 0 : permissions.hlsStreaming) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Common.StreamCard, {
      testId: "hls_stream",
      title: "Live Stream with HLS",
      subtitle: "Stream to millions, edit and control what the viewer sees and more!",
      css: {
        my: "$8"
      },
      onClick: function onClick() {
        return setShowHLS(true);
      },
      Icon: _reactIcons.GoLiveIcon
    }), (permissions === null || permissions === void 0 ? void 0 : permissions.rtmpStreaming) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Common.StreamCard, {
      testId: "rtmp_stream",
      title: "Stream live to Facebook, Twitch, and others",
      subtitle: "Stream to a specific destination directly from your app.",
      css: {
        my: "$8"
      },
      onClick: function onClick() {
        setShowRTMP(true);
      },
      Icon: _RTMPIcon.RTMPIcon
    }), showHLS && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HLSStreaming.HLSStreaming, {
      onBack: function onBack() {
        return setShowHLS(false);
      }
    }), showRTMP && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RTMPStreaming.RTMPStreaming, {
      onBack: function onBack() {
        return setShowRTMP(false);
      }
    })]
  });
};
exports.StreamingLanding = StreamingLanding;